const dentalTourism = {
  hero: {
    title: "Οδοντιατρικός Τουρισμός στη Βουλγαρία",
    description:
      "Τα ολοκληρωμένα πακέτα οδοντιατρικού τουρισμού μας συνδυάζουν εξαιρετικές οδοντιατρικές θεραπείες με μια αξέχαστη ταξιδιωτική εμπειρία.",
    ctas: {
      primary: "Κλείστε Δωρεάν Εξέταση",
      secondary: "Μάθετε Περισσότερα",
    },
    imageAlt: "Οδοντιατρικός Τουρισμός στη Βουλγαρία - Προσγείωση Αεροπλάνου",
  },
  benefits: {
    heading: "ΓΙΑΤΙ ΝΑ ΜΑΣ ΕΠΙΛΕΞΕΤΕ",
    intro:
      "Ζήστε τον ιδανικό συνδυασμό προσιτής, υψηλής ποιότητας οδοντιατρικής φροντίδας και αξέχαστων ταξιδιωτικών εμπειριών",
    items: [
      {
        title: "Εξοικονόμηση Κόστους",
        description:
          "Εξοικονομήστε έως και 70% σε οδοντιατρικές θεραπείες σε σύγκριση με τις τιμές της Δυτικής Ευρώπης και της Βόρειας Αμερικής, χωρίς συμβιβασμούς στην ποιότητα.",
      },
      {
        title: "Ποιοτική Φροντίδα",
        description:
          "Οι οδοντίατροί μας είναι εξειδικευμένοι με διεθνή κατάρτιση και χρησιμοποιούν την πιο σύγχρονη οδοντιατρική τεχνολογία και υλικά.",
      },
      {
        title: "Πακέτα Όλα-Σε-Ένα",
        description:
          "Περιεκτικά πακέτα που περιλαμβάνουν θεραπεία, διαμονή, μεταφορές από/προς το αεροδρόμιο και προαιρετικές τουριστικές δραστηριότητες.",
      },
      {
        title: "Αποδοτικότητα Χρόνου",
        description:
          "Σύνθετες θεραπείες που αλλού μπορεί να απαιτούν μήνες, ολοκληρώνονται σε μία μόνο επίσκεψη χάρη στον αποδοτικό μας προγραμματισμό.",
      },
      {
        title: "Πολιτιστική Εμπειρία",
        description:
          "Συνδυάστε τη θεραπεία σας με ένα πλούσιο ταξίδι γνωρίζοντας την ιστορία και τη φυσική ομορφιά της Βουλγαρίας.",
      },
      {
        title: "Εξατομικευμένη Φροντίδα",
        description:
          "Λάβετε εξατομικευμένη προσοχή από εξειδικευμένο προσωπικό που μιλάει Αγγλικά-Ελληνικά και σας καθοδηγεί σε κάθε βήμα του ταξιδιού σας.",
      },
    ],
  },
  process: {
    heading: "ΠΩΣ ΛΕΙΤΟΥΡΓΕΙ",
    intro:
      "Η απλοποιημένη διαδικασία οδοντιατρικού τουρισμού μας κάνει εύκολη την πρόσβαση σε ποιοτική οδοντιατρική φροντίδα ενώ απολαμβάνετε ένα αξέχαστο ταξίδι στη Βουλγαρία",
    steps: [
      {
        number: "01",
        title: "Αρχική Συμβουλευτική",
        description:
          "Επικοινωνήστε μαζί μας για μια δωρεάν διαδικτυακή συμβουλευτική ώστε να συζητήσουμε τις οδοντιατρικές σας ανάγκες, τις διαθέσιμες θεραπείες και το εκτιμώμενο κόστος.",
      },
      {
        number: "02",
        title: "Σχέδιο Θεραπείας",
        description:
          "Σας παρέχουμε ένα λεπτομερές σχέδιο θεραπείας με εκτίμηση κόστους και επιλογές χρονοδιαγράμματος για την επίσκεψή σας στη Βουλγαρία.",
      },
      {
        number: "03",
        title: "Ταξιδιωτικές Ρυθμίσεις",
        description:
          "Οι συντονιστές μας βοηθούν στην κράτηση πτήσεων, επιλογές διαμονής και μεταφορά από το αεροδρόμιο στο ξενοδοχείο.",
      },
      {
        number: "04",
        title: "Οδοντιατρική Θεραπεία",
        description:
          "Λάβετε υψηλής ποιότητας οδοντιατρική φροντίδα από τους έμπειρους ειδικούς μας στις σύγχρονες εγκαταστάσεις μας στη Βουλγαρία.",
      },
      {
        number: "05",
        title: "Τουριστικές Δραστηριότητες",
        description:
          "Μεταξύ των ραντεβού, εξερευνήστε τη Βουλγαρία με τις οργανωμένες μας ξεναγήσεις και γνωρίστε την τοπική κουλτούρα, κουζίνα και αξιοθέατα.",
      },
      {
        number: "06",
        title: "Μεταθεραπευτική Φροντίδα",
        description:
          "Επιστρέψτε στο σπίτι με το νέο σας χαμόγελο και λάβετε εξ αποστάσεως υποστήριξη για να εξασφαλίσουμε την πλήρη ικανοποίησή σας.",
      },
    ],
  },
  faq: {
    heading: "ΣΥΧΝΕΣ ΕΡΩΤΗΣΕΙΣ",
    intro:
      "Βρείτε απαντήσεις στις πιο συχνές ερωτήσεις σχετικά με τις υπηρεσίες οδοντιατρικού τουρισμού στη Βουλγαρία",
    items: [
      {
        question:
          "Πόσα μπορώ να εξοικονομήσω με τον οδοντιατρικό τουρισμό στη Βουλγαρία;",
        answer:
          "Οι ασθενείς εξοικονομούν συνήθως 50-70% σε οδοντιατρικές θεραπείες σε σύγκριση με τις τιμές της Δυτικής Ευρώπης και της Βόρειας Αμερικής. Για παράδειγμα, ένα εμφύτευμα που μπορεί να κοστίζει €3.000 στη Δυτική Ευρώπη, στη Βουλγαρία κοστίζει περίπου €900-1.200.",
      },
      {
        question: "Οι οδοντίατροί σας είναι καταρτισμένοι και έμπειροι;",
        answer:
          "Ναι, όλοι οι οδοντίατροί μας είναι εξαιρετικά καταρτισμένοι, με πτυχία από αναγνωρισμένες οδοντιατρικές σχολές. Πολλοί έχουν διεθνή εκπαίδευση και πιστοποιήσεις, και όλοι ενημερώνονται διαρκώς για τις τελευταίες τεχνικές και τεχνολογίες.",
      },
      {
        question:
          "Πόσο καιρό θα χρειαστεί να μείνω στη Βουλγαρία για τη θεραπεία μου;",
        answer:
          "Η διάρκεια της διαμονής εξαρτάται από το θεραπευτικό σας πλάνο. Απλές θεραπείες μπορεί να απαιτούν 2-3 ημέρες, ενώ πιο σύνθετες όπως η αποκατάσταση ολόκληρου του στόματος ίσως χρειαστούν 7-14 ημέρες, συχνά με διαλείμματα μεταξύ των συνεδριών.",
      },
      {
        question: "Παρέχετε διαμονή και μεταφορές;",
        answer:
          "Ναι, προσφέρουμε ολοκληρωμένα πακέτα που περιλαμβάνουν προτάσεις για διαμονή, μεταφορά από/προς το αεροδρόμιο και μετακινήσεις προς και από την κλινική. Μπορούμε να κανονίσουμε τα πάντα ανάλογα με τις προτιμήσεις και τον προϋπολογισμό σας.",
      },
      {
        question:
          "Τι συμβαίνει αν χρειαστώ φροντίδα μετά την επιστροφή στο σπίτι;",
        answer:
          "Παρέχουμε αναλυτικές οδηγίες φροντίδας πριν την αναχώρησή σας. Αν χρειαστείτε βοήθεια, προσφέρουμε απομακρυσμένες συμβουλές μέσω βιντεοκλήσης. Για θεραπείες με εγγύηση, συνεργαζόμαστε με κλινικές σε διάφορες χώρες για ενδεχόμενη παρακολούθηση.",
      },
      {
        question: "Είναι ασφαλές να ταξιδέψω στη Βουλγαρία;",
        answer:
          "Ναι, η Βουλγαρία είναι μια ασφαλής χώρα με σχετικά χαμηλά ποσοστά εγκληματικότητας σε σύγκριση με πολλές δυτικές χώρες. Είναι μέλος της Ευρωπαϊκής Ένωσης και τηρεί τα ευρωπαϊκά πρότυπα υγείας και ασφάλειας.",
      },
      {
        question:
          "Ποια τουριστικά αξιοθέατα μπορώ να επισκεφθώ μεταξύ των ραντεβού;",
        answer:
          "Η Βουλγαρία προσφέρει πολλά: όμορφες παραλίες στη Μαύρη Θάλασσα, ορεινά θέρετρα, ιστορικές πόλεις, ρωμαϊκά ερείπια και φημισμένες ιαματικές πηγές. Μπορούμε να οργανώσουμε ξεναγήσεις ή να σας προτείνουμε δραστηριότητες ανάλογα με τα ενδιαφέροντά σας.",
      },
    ],
    bottomLine: "Έχετε ακόμα ερωτήσεις για τις υπηρεσίες οδοντιατρικού τουρισμού μας;",
    cta: "Κλείστε Δωρεάν Εξέταση",
  },
};

export default dentalTourism;

